import { useQuery } from "@tanstack/react-query";
import { todayQuickActionsEncountersQueryOptions } from "../api/queries";
import AppointmentCard from "./cards/appointment-card";
import NoPreviewCard from "./cards/no-preview-card";
import { QuickActionCardSkeleton } from "./cards/quick-action-card-skeleton";
import { getAppointmentsByIdQueryOptions } from "../../encounters/api/queries/appointments";
import { useParams } from "@tanstack/react-router";
import { getApiProgram } from "~/lib/utils";

const Appointments = () => {
  const {program} = useParams({strict: false})
  const apiProgram = getApiProgram(program ?? "")
  const { data, isLoading } = useQuery(todayQuickActionsEncountersQueryOptions({
    limit: 1,
    skip: 0,
    type: "appointment",
    // date_filter: "today",
    program: apiProgram,
    type_sort_order: "appointment",
    status: "unresolved",
    sort: "new_old"
  }));

  const { data: appointment, isLoading: appointmentLoading } = useQuery(getAppointmentsByIdQueryOptions({
    id: data?.id ?? ""
  }));

  return (
    <div className="flex flex-col gap-4">
      {isLoading || appointmentLoading ? (<QuickActionCardSkeleton />) : !isLoading && data ? (
        <div>
          {data && (
            <AppointmentCard
              item={data}
              meetingLink={appointment?.meetingLink ?? ""}
              program={program ?? ""}
            />
          )}
        </div>
      ) : (
        <NoPreviewCard
          icon="/assets/notifications.svg"
          title="Nothing to Display"
          description="You have no encounters to see today, when you do, they will appear here"
          className="w-full h-[440px]"
        />
      )}
    </div>
  );
};

export default Appointments;

